import React from "react";
import { GeneralInfoTab } from "../GeneralInfoTab";
import { GeneralInfoTabAutoPatrol } from "../GeneralInfoTabAutoPatrol";
import { SchedulesTab } from "../SchedulesTab";
import { SMTPTab } from "../SMTPTab";
import { RecordingServerTab } from "../RecordingServerTab";
import { CameraHealthTab } from "../CameraHealthTab";
import { WebhooksTab } from "../WebhooksTab";
import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";
import { handleCreateInitialTimeSchedules } from "./handleCreateInitialTimeSchedules";
import { handleConvertSchedulesToBooleanArrays } from "./handleConvertSchedulesToBooleanArrays";
import { handleCreateDuskToDawn } from "./handleCreateDuskToDawn";
import { handleCreateDuskToDawnLocationPlusBuffer } from "../../SitesPage/SitesPageUtils/handleCreateDuskToDawnLocationPlusBuffer";
import { EvalinkTab } from "../EvalinkTab";
import { WireGuardTab } from "../WireGuardTab";
import { WireGuardTunnel } from "./siteAboutInterfaces";

export const handleCancelButtonClick = (
  setEditMode: any,
  clickedTab: any,
  setActiveTab: any,
  backupSiteSchedules: any,
  siteInfo: any,
  setRecordingServerPatchObject: any,
  healthCheckData: any,
  webhooksInfo: any,
  siteInfoBackup: any,
  setSiteInfo: any,
  vmsVariablesBackup: any,
  setVmsVariables: any,
  setSiteSchedules: any,
  wireguardTunnels: WireGuardTunnel[],
  wireguardTunnelsLoading: boolean,
  selectedWireguardTunnelId: number | null,
  setSelectedWireguardTunnelId: React.Dispatch<
    React.SetStateAction<number | null>
  >,
  clearWireGuardEditSession: () => void,
  setWireguardChangesMade: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const {
    setHealthCheckMetricsData,
    setScheduleGridEditable,
    setTimeRanges,
    setGrid,
    setDuskToDawn,
    setDuskToDawnLocation,
    schedulesIndex,
    setAutoPatrolScheduleHealthchckMetrics,
    setAutoPatrolSchedules,
    resetAutoPatrolFlexIgnoreZonesForSite,
    flexSchedulesOn,
    setEvalinkPatchObject,
    evalinkData,
  } = useSiteAboutStore.getState();

  const backupSiteInfo = siteInfoBackup;

  const backupHealthCheckMetrics = localStorage.getItem(
    "backupHealthCheckMetricsData"
  );
  if (backupHealthCheckMetrics) {
    setHealthCheckMetricsData(JSON.parse(backupHealthCheckMetrics));
  }

  setSiteInfo(backupSiteInfo);
  setVmsVariables(vmsVariablesBackup);
  setEditMode(false);
  setScheduleGridEditable(false);

  if (evalinkData) {
    setEvalinkPatchObject({
      evalink_token: evalinkData.evalink_token,
      evalink_device_id: evalinkData.evalink_device_id,
      evalink_company_id: evalinkData.evalink_company_id,
    });
  }

  if (backupSiteInfo?.integration_type_name === "milestone") {
    const recordingServerBackup = localStorage.getItem("recordingServerBackup");
    if (recordingServerBackup) {
      setRecordingServerPatchObject(JSON.parse(recordingServerBackup));
    }
  }

  const flexScheduleBackup = localStorage.getItem("backUpFlexSchedule");
  const standardScheduleBackup = localStorage.getItem("backUpStandardSchedule");
  if (flexSchedulesOn && flexScheduleBackup) {
    setSiteSchedules(JSON.parse(flexScheduleBackup));
  } else if (!flexSchedulesOn && standardScheduleBackup) {
    setSiteSchedules(JSON.parse(standardScheduleBackup));
  }

  if (
    backupSiteSchedules?.length > 0 &&
    backupSiteSchedules[schedulesIndex]?.schedule
  ) {
    setTimeRanges(
      handleCreateInitialTimeSchedules(
        backupSiteSchedules[schedulesIndex].schedule
      )
    );
    setGrid(
      handleConvertSchedulesToBooleanArrays(
        backupSiteSchedules[schedulesIndex].schedule
      )
    );
    setDuskToDawn(
      handleCreateDuskToDawn(backupSiteSchedules[schedulesIndex].schedule)
    );
    setDuskToDawnLocation(
      handleCreateDuskToDawnLocationPlusBuffer(
        backupSiteSchedules[schedulesIndex].schedule
      )
    );
  }

  const backupAutoPatrolMetrics = localStorage.getItem(
    "backupAutoPatrolScheduleHealthchckMetrics"
  );
  if (backupAutoPatrolMetrics) {
    setAutoPatrolScheduleHealthchckMetrics(JSON.parse(backupAutoPatrolMetrics));
  }

  const backupAutoPatrol = localStorage.getItem("backupAutoPatrolSchedules");
  if (backupAutoPatrol) {
    setAutoPatrolSchedules(JSON.parse(backupAutoPatrol));
  }
  if (backupSiteInfo?.id) {
    resetAutoPatrolFlexIgnoreZonesForSite(Number(backupSiteInfo.id));
  }

  const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";

  if (clickedTab === "one") {
    if (isAutoPatrol) {
      // For AutoPatrol sites, restore Zustand store state
      const {
        setSiteInfo: setZustandSiteInfo,
        setVmsVariables: setZustandVmsVariables,
        setGeneralInfoTabPatchObject,
        setGeneralInfoTabChangesMade,
      } = useSiteAboutStore.getState();
      setZustandSiteInfo(backupSiteInfo);
      setZustandVmsVariables(vmsVariablesBackup);
      setGeneralInfoTabPatchObject({});
      setGeneralInfoTabChangesMade(false);
      setActiveTab(<GeneralInfoTabAutoPatrol editMode={false} />);
    } else {
      setActiveTab(
        <GeneralInfoTab
          siteInfo={backupSiteInfo}
          setSiteInfo={setSiteInfo}
          setActiveTab={setActiveTab}
          vmsVariables={vmsVariablesBackup}
        />
      );
    }
  } else if (clickedTab === "three") {
    setActiveTab(<SchedulesTab siteInfo={backupSiteInfo} />);
  } else if (clickedTab === "four") {
    setActiveTab(<SMTPTab />);
  } else if (clickedTab === "five") {
    const recordingServerBackup = localStorage.getItem("recordingServerBackup");
    setActiveTab(
      <RecordingServerTab
        recordingServerData={
          recordingServerBackup ? JSON.parse(recordingServerBackup) : undefined
        }
      />
    );
  } else if (clickedTab === "six") {
    setActiveTab(
      <CameraHealthTab
        healthCheckData={healthCheckData}
        siteInfo={backupSiteInfo}
      />
    );
  } else if (clickedTab === "seven") {
    setActiveTab(<WebhooksTab webhooksInfo={webhooksInfo} />);
  } else if (clickedTab === "eight") {
    setActiveTab(<EvalinkTab />);
  } else if (clickedTab === "nine") {
    clearWireGuardEditSession();
    setWireguardChangesMade(false);
    setActiveTab(
      <WireGuardTab
        wireguardTunnels={wireguardTunnels}
        wireguardTunnelsLoading={wireguardTunnelsLoading}
        selectedTunnelId={selectedWireguardTunnelId}
        onSelectTunnelId={(id) => setSelectedWireguardTunnelId(id)}
      />
    );
  }
};
